export default "__VITE_ASSET__f7847ed4__"